import Vue from "vue";
import Router from "vue-router";
import axios from "axios";
import apiConfig from "./api.config";
import Home from "./views/Home.vue";
import Fra from "./views/Fra.vue";
import screenIndexPage from "./views/display/screenIndexPage.vue";

Vue.use(Router);
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalPush.call(this, location, onResolve, onReject);
  return originalPush.call(this, location).catch((err) => err);
};

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/login",
      name: "login",
      meta: {
        title: "登录",
        auth: true,
      },
      component: () => import("./views/Login.vue"),
      hidden: true,
    },
    {
      path: "/index",
      name: "index",
      icon: "all",
      meta: {
        title: "信息概览",
        info: "Information Overview",
        auth: true,
      },
      redirect: "/index/indexInfo",
      component: Fra,
      leaf: true,
      children: [
        {
          path: "",
          component: () => import("./views/Index.vue"),
          name: "indexInfo",
          meta: {
            title: "",
            auth: true,
          },
          hidden: true,
        },
      ],
    },
    {
      path: "/servicePackage",
      name: "servicePackage",
      icon: "s_package",
      meta: {
        title: "服务套餐",
        info: "Service Package",
        auth: true,
      },
      redirect: "/servicePackage",
      component: Fra,
      leaf: true,
      children: [
        {
          path: "",
          component: () => import("./views/servicePackage.vue"),
          name: "servicePackage",
          meta: {
            title: "服务套餐",
            auth: true,
          },
          hidden: true,
        },
      ],
    },
    {
      path: "/largeScreen",
      name: "largeScreen",
      icon: "all",
      meta: {
        title: "可视化大屏",
        info: "Visual large screen",
        auth: true,
      },
      redirect: "/largeScreen/ScreenPage",
      component: Fra,
      children: [
        {
          path: "screenPage",
          component: screenIndexPage,
          name: "screenPage",
          meta: {
            title: "可视化大屏",
            info: "Visual large screen",
            auth: true,
          },
          redirect: "/largeScreen/screenPage/indexBigScreen",
          children: [
            {
              path: "indexBigScreen",
              component: () => import("./views/display/displayScreenIndex.vue"),
              name: "indexBigScreen",
              meta: {
                title: "信息概览（大屏版）",
                info: "Information Overview (Large Screen)",
                auth: true,
              },
            },
            {
              path: "deviceBigScreen",
              component: () => import("./views/display/displayDevice.vue"),
              name: "deviceBigScreen",
              meta: {
                title: "电梯AI运行诊断（大屏版）",
                info: "Elevator AI operation diagnosis (Large Screen)",
                auth: true,
              },
            },
            {
              path: "riskMonitor",
              component: () => import("./views/display/displayRiskMonitor.vue"),
              name: "riskMonitor",
              meta: {
                title: "电梯风险监测（大屏版）",
                info: "Elevator risk monitoring (Large Screen)",
                auth: true,
              },
            },
            {
              path: "deviceMonitor",
              component: () =>
                import("./views/display/displayDeviceMonitor.vue"),
              name: "deviceMonitor",
              meta: {
                title: "电梯设备巡视（大屏版）",
                info: "Elevator device monitoring (Large Screen)",
                auth: true,
              },
            },
            // {
            //     path: "analysisBigScreen",
            //     component: () =>
            //         import("./views/display/displayAnalysis.vue"),
            //     name: "analysisBigScreen",
            //     meta: {
            //         title: "电梯体检分析（大屏版）",
            //         info: "Elevator medical examination analysis (Large Screen)",
            //         auth: true
            //     },
            // },
          ],
        },
      ],
    },
    {
      path: "/elevatorAnalyse",
      name: "elevatorAnalyse",
      icon: "pie",
      meta: {
        title: "电梯体检分析",
        info: "Physical Examination Analysis Screen",
        auth: true,
      },
      component: Fra,
      leaf: true,
      children: [
        {
          path: "",
          component: () => import("./views/display/displayAnalysis.vue"),
          name: "elevatorAnalyseIndex",
          meta: {
            title: "电梯体检分析",
            auth: true,
          },
          hidden: true,
        },
      ],
    },
    {
      path: "/manage",
      name: "manage",
      icon: "run",
      meta: {
        title: "电梯运行管理",
        info: "Elevator Operation Management",
        auth: true,
      },
      redirect: "/manage/device",
      component: Fra,
      children: [
        {
          path: "device",
          component: () => import("./views/manage/device.vue"),
          name: "device",
          meta: {
            title: "设备巡视",
            auth: true,
          },
        },
        {
          path: "monitor",
          component: () => import("./views/manage/monitor.vue"),
          name: "monitor",
          meta: {
            title: "实时监视",
            auth: true,
          },
        },
        {
          path: "alarm",
          component: () => import("./views/manage/alarm.vue"),
          name: "alarm",
          meta: {
            title: "报警管理",
            auth: true,
          },
        },
        {
          path: "message",
          component: () => import("./views/manage/message.vue"),
          name: "message",
          meta: {
            title: "故障短信管理",
            auth: true,
          },
        },
        {
          path: "faultReport",
          component: () => import("./views/manage/faultReport.vue"),
          name: "faultReport",
          meta: {
            title: "故障处理",
            auth: true,
          },
        },
        {
          path: "elevatorVideo",
          component: () => import("./views/manage/elevatorVideo.vue"),
          name: "elevatorVideo",
          meta: {
            title: "视频设备管理",
            auth: true,
          },
        },
        {
          path: "elevatorVideoLog",
          component: () => import("./views/manage/elevatorVideoLog.vue"),
          name: "elevatorVideoLog",
          meta: {
            title: "视频日志管理",
            auth: true,
          },
        },
        {
          path: "riskConfirmLog",
          component: () => import("./views/manage/riskConfirmLog.vue"),
          name: "riskConfirmLog",
          meta: {
            title: "用户确认风险告知书记录",
            auth: true,
          },
        },
        {
          path: "lcdEquipment",
          component: () => import("./views/manage/lcdEquipment.vue"),
          name: "lcdEquipment",
          meta: {
            title: "液晶屏设备管理",
            auth: true,
          },
        },
        {
          path: "malfunctions",
          component: () => import("./views/manage/malfunctions.vue"),
          name: "malfunctions",
          meta: {
            title: "故障信息管理",
            auth: true,
          },
        },
        {
          path: "diagnosis",
          component: () => import("./views/manage/diagnosis.vue"),
          name: "diagnosis",
          meta: {
            title: "诊断信息管理",
            auth: true,
          },
        },
      ],
    },
    {
      path: "/report",
      name: "report",
      icon: "report",
      meta: {
        title: "日周月巡检报告",
        info: "Inspection report management",
        auth: true,
      },
      redirect: "/report/elevator",
      component: Fra,
      children: [
        {
          path: "elevator",
          component: () => import("./views/report/elevator"),
          name: "elevator",
          meta: {
            title: "电梯巡检报告",
            auth: true,
          },
        },
        {
          path: "domain",
          component: () => import("./views/report/domain"),
          name: "domain",
          meta: {
            title: "地盘报告统计",
            auth: true,
          },
        },
        {
          path: "elevatorDaily",
          component: () => import("./views/report/elevator/daily"),
          name: "elevatorDaily",
          hidden: true,
          meta: {
            title: "电梯巡检日报",
            subtitle: "()",
            auth: false,
          },
        },
        {
          path: "weekly",
          component: () => import("./views/report/monthly"),
          name: "elevatorWeekly",
          hidden: true,
          meta: {
            title: "电梯巡检周报",
            subtitle: "()",
            auth: false,
          },
        },
        {
          path: "monthly",
          component: () => import("./views/report/monthly"),
          name: "elevatorMonthly",
          hidden: true,
          meta: {
            title: "电梯巡检月报",
            subtitle: "()",
            auth: false,
          },
        },
        {
          path: "daily",
          component: () => import("./views/report/monthly"),
          name: "domainDaily",
          hidden: true,
          meta: {
            title: "地盘巡检日报",
            subtitle: "()",
            auth: false,
          },
        },
        {
          path: "domainWeekly",
          component: () => import("./views/report/domain/weekly"),
          name: "domainWeekly",
          hidden: true,
          meta: {
            title: "地盘巡检周报",
            subtitle: "()",
            auth: false,
          },
        },
        {
          path: "domainMonthly",
          component: () => import("./views/report/domain/weekly"),
          name: "domainMonthly",
          hidden: true,
          meta: {
            title: "地盘巡检月报",
            subtitle: "()",
            auth: false,
          },
        },
      ],
    },
    {
      path: "/maintain",
      name: "maintain",
      icon: "shield",
      meta: {
        title: "维保管理",
        info: "Maintenance Management",
        auth: true,
      },
      redirect: "/maintain/maintainManage",
      component: Fra,
      children: [
        {
          path: "maintainManage",
          component: () => import("./views/maintain/maintainManage.vue"),
          name: "maintainManage",
          meta: {
            title: "无纸化保养记录",
            auth: true,
          },
        },
        // {
        //     path: "maintainMsg",
        //     component: () =>
        //         import ("./views/maintain/maintainMsg.vue"),
        //     name: "maintainMsg",
        //     meta: {
        //         title: "维保停梯短信",
        //         auth: true
        //     }
        // },
        {
          path: "supervise",
          component: () => import("./views/maintain/supervise.vue"),
          name: "supervise",
          meta: {
            title: "维保监督",
            auth: true,
          },
        },
        {
          path: "propertyQuote",
          component: () => import("./views/maintain/propertyQuote.vue"),
          name: "propertyQuote",
          meta: {
            title: "物业报价单管理",
            auth: true,
          },
        },
        {
          path: "propertyPayable",
          component: () => import("./views/maintain/propertyPayable.vue"),
          name: "propertyPayable",
          meta: {
            title: "物业应付款管理",
            auth: true,
          },
        },
        {
          path: "annualInspectionPlan",
          component: () => import("./views/maintain/annualInspectionPlan.vue"),
          name: "annualInspectionPlan",
          meta: {
            title: "年检计划管理",
            auth: true,
          },
        },
        {
          path: "partsProposal",
          component: () => import("./views/maintain/partsProposal.vue"),
          name: "partsProposal",
          meta: {
            title: "配件提案书管理",
            auth: true,
          },
        },
        {
          path: "faultReport",
          component: () => import("./views/maintain/faultReport.vue"),
          name: "fdFaultReport",
          meta: {
            title: "故障上报管理",
            auth: true,
          },
        },
        {
          path: "serviceFeedback",
          component: () => import("./views/maintain/serviceFeedback.vue"),
          name: "serviceFeedback",
          meta: {
            title: "服务问题反馈管理",
            auth: true,
          },
        },
      ],
    },
    {
      path: "/analyse",
      name: "analyse",
      icon: "pie",
      meta: {
        title: "统计分析",
        info: "Statistical Analysis",
        auth: true,
      },
      redirect: "/analyse/analyseIndex",
      component: Fra,
      leaf: true,
      children: [
        {
          path: "",
          component: () => import("./views/analyse/analyseIndex.vue"),
          name: "analyseIndex",
          meta: {
            title: "",
            auth: true,
          },
          hidden: true,
        },
      ],
    },
    {
      path: "/display",
      name: "display",
      icon: "screen",
      meta: {
        title: "投屏展示",
        info: "Display Screen",
        auth: true,
      },
      redirect: "/display/displayIndex",
      component: Fra,
      leaf: true,
      children: [
        {
          path: "displayIndex",
          component: () => import("./views/display/displayIndex.vue"),
          name: "displayIndex",
          meta: {
            title: "",
            auth: true,
          },
          hidden: true,
        },
        {
          path: "imagePage",
          name: "imagePage",
          meta: {
            title: "图片页展示",
            auth: true,
          },
          component: () => import("./views/display/imagePage.vue"),
          hidden: true,
        },
      ],
    },
    {
      path: "/info",
      name: "info",
      icon: "cog",
      meta: {
        title: "基础信息",
        info: "Basic Informations",
        auth: true,
      },
      redirect: "/info/lift",
      component: Fra,
      children: [
        {
          path: "lift",
          component: () => import("./views/setting/lift.vue"),
          name: "lift",
          meta: {
            title: "电梯档案",
            auth: true,
          },
        },
        {
          path: "estate",
          component: () => import("./views/setting/estate.vue"),
          name: "estate",
          meta: {
            title: "物业信息维护",
            auth: true,
          },
        },
        {
          path: "proprietor",
          component: () => import("./views/setting/proprietor.vue"),
          name: "proprietor",
          meta: {
            title: "业主信息维护",
            auth: true,
          },
        },
        {
          path: "account",
          component: () => import("./views/setting/account.vue"),
          name: "account",
          meta: {
            title: "账号管理功能",
            auth: true,
          },
        },
        {
          path: "role",
          component: () => import("./views/setting/role.vue"),
          name: "role",
          meta: {
            title: "角色管理功能",
            auth: true,
          },
        },
        {
          path: "feedback",
          component: () => import("./views/setting/feedback.vue"),
          name: "feedback",
          meta: {
            title: "异常反馈功能",
            auth: true,
          },
        },
        {
          path: "feedbackEdit",
          component: () => import("./views/setting/feedbackEdit.vue"),
          name: "feedbackEdit",
          meta: {
            title: "异常反馈功能编辑",
            auth: true,
          },
          hidden: true,
        },
        {
          path: "log",
          component: () => import("./views/setting/log.vue"),
          name: "log",
          meta: {
            title: "日志管理功能",
            auth: true,
          },
        },
        {
          path: "msg",
          component: () => import("./views/setting/msg.vue"),
          name: "msg",
          meta: {
            title: "短信接收人管理",
            auth: true,
          },
        },
        {
          path: "weixin",
          component: () => import("./views/setting/weixin.vue"),
          name: "weixin",
          meta: {
            title: "微信用户管理",
            auth: true,
          },
        },
        {
          path: "alarmPushRecord",
          component: () => import("./views/setting/alarmPushRecord.vue"),
          name: "alarmPushRecord",
          meta: {
            title: "微信推送管理",
            auth: true,
          },
        },
        {
          path: "notice",
          component: () => import("./views/setting/notice.vue"),
          name: "notice",
          meta: {
            title: "公告管理",
            auth: true,
          },
        },
        {
          path: "historyNotice",
          name: "historyNotice",
          meta: {
            title: "公告历史",
            auth: true,
          },
          component: () => import("./views/setting/historyNotice.vue"),
          hidden: true,
        },
        {
          path: "thirdPartyUser",
          name: "thirdPartyUser",
          meta: {
            title: "第三方应用账号管理",
            auth: true,
          },
          component: () => import("./views/setting/thirdParty.vue"),
        },
        {
          path: "externalSystem",
          name: "externalSystem",
          meta: {
            title: "第三方系统信息管理",
            auth: true,
          },
          component: () => import("./views/setting/externalSystem.vue"),
        },
        {
          path: "accountVideoDevice",
          component: () => import("./views/setting/accountVideoDevice.vue"),
          name: "accountVideoDevice",
          meta: {
            title: "账户视频设备管理",
            auth: true,
          },
        },
      ],
    },
    {
      path: "/default",
      name: "default",
      meta: {
        title: "",
        auth: true,
      },
      component: () => import("./views/default.vue"),
      hidden: true,
    },
    {
      path: "/oms",
      name: "oms",
      meta: {
        title: "Bivale",
        info: "Bivale Integrated Building Management System",
        auth: true,
      },
      component: () => import("./views/oms.vue"),
      hidden: true,
    },
  ],
});

function getUserByAccessToken(token, to, next) {
  axios
    .get(apiConfig.get_user_by_access_token, {
      params: {
        token: token,
      },
      headers: {
        Authorization: token,
      },
    })
    .then((response) => {
      let result = response.data;
      if (result.code == 0) {
        let data = result.data;
        localStorage.setItem("token", token);
        localStorage.setItem("token_timestamp", Date.now());
        localStorage.setItem("access_token", token);
        localStorage.setItem("user", JSON.stringify(data));
        localStorage.setItem("permissions", JSON.stringify(data.permissions));
        localStorage.setItem(
          "indexPermissions",
          JSON.stringify(data.indexPermissions),
        );
        if (to.name == "deviceBigScreen") {
          next();
        } else {
          next("/display?fromtoken=true");
        }
      }
    })
    .catch((error) => {
      this.$sentry.captureException(error);
    });
}

function isExpired(ttl) {
  const saved = Number(localStorage.getItem("token_timestamp"));
  if (!saved) return true; // 没记录过，视为已过期
  return Date.now() - saved > ttl;
}


router.beforeEach((to, from, next) => {
  if (localStorage.getItem("token") == null) {
    if (to.name == "displayIndex" || to.name == "deviceBigScreen") {
      let token = to.query.token;
      if (token) {
        getUserByAccessToken(token, to, next);
      } else {
        next("/login");
      }
    } else if (to.name == "login" || to.name == "oms") {
      next();
    } else {
      next("/login");
    }
  } else {
    if(isExpired(window.config.loginExpireTime * 1000)) {
      localStorage.clear();
      sessionStorage.clear();
      next("/login");
    }
    let permissionsJson = localStorage.getItem("permissions");
    let userJson = localStorage.getItem("user");
    if (to.name == "login") {
      let user = JSON.parse(userJson);
      if(user.roleType == 1) {
        next("/index");
      }
      if (permissionsJson) {
        let permissions = JSON.parse(permissionsJson);
        if (permissions.length > 0) {
          next(
            permissions.filter((item) => item.path && item.type == 1)[0].path,
          );
        } else {
          next("/default");
        }
      }
    } else {
      if (userJson) {
        let user = JSON.parse(userJson);
        if (user.roleType != 1) {
          if (to.name != "login" && to.name != "oms") {
            if (permissionsJson) {
              let permissions = JSON.parse(permissionsJson);
              if (permissions.length == 0) {
                if (to.name == "default") {
                  next();
                } else {
                  next("/default");
                }
              } else if (
                to.name != "imagePage" &&
                (to.name == null ||
                  permissions.filter(
                    (item) =>
                      to.name.startsWith(item.name) ||
                      (to.name == "historyNotice" && item.name == "notice"),
                  ).length == 0 ||
                  to.name == "default")
              ) {
                next(
                  permissions.filter((item) => item.path && item.type == 1)[0]
                    .path,
                );
              }
            }
          } else if (to.name == null) {
            next("/index");
          }
        } else if (to.name == "default") {
          next("/login");
        } else if (to.name == null) {
          next("/index");
        }
      } else {
        localStorage.clear();
        next("/login");
      }
    }
    next();
  }
});

export default router;
